import { Grid } from '@mui/material'
import * as React from 'react'
import { IMetricProps } from './types'
import { ValueDesc, ValueMetric } from './styled'

const Metric: React.FC<IMetricProps> = ({ value, description }) => {
  return (
    <Grid
      container
      spacing={0}
      sx={{ height: '100%', display: 'flex', justifyContent: 'center' }}
    >
      <Grid item xs={12}>
        <ValueMetric>{value}</ValueMetric>
      </Grid>
      <Grid item xs={12}>
        <ValueDesc>{description}</ValueDesc>
      </Grid>
    </Grid>
  )
}

export default Metric
